import{a as t}from"./chunk-2HA4XQFN.js";var e=t(i=>i.split(" ").map(s=>s[0].toUpperCase()+s.slice(1)).join(" "),"capitalize");export{e as a};
